<div class="event-progress-bar">
  <span
    class="event-progress-bar--progress-line"
    [@progressBar]="{ value: progress, params: { newProgress: progress } }"
    [class]="className"
  ></span>
</div>
